import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { fetchAPI } from '@/api';
import { updateSubscriptionDataFromHook } from '@/actions';

const useSubscriptionPlans = (auth) => {
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const [isLoading, setIsLoading] = useState(true);
    const [subscription, setSubscription] = useState(null);
    const [currentPlan, setCurrentPlan] = useState(null);
    const [plans, setPlans] = useState(null);
    const [planPeriod, setPlanPeriod] = useState('month');
    const [trialEndDate, setTrialEndDate] = useState(null);
    const [discountPercent, setDiscountPercent] = useState(null);
    
    useEffect(() => {
        const fetchData = async () => {
            try {
                const planParam = searchParams.get('plan');
                const billedParam = searchParams.get('billed');

                const params = { showNewPlans: true };

                if (planParam) params.plan = planParam;
                if (billedParam) params.billed = billedParam;

                const response = await fetchAPI("/billing/plans", auth.user.token, params);
                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }

                const responseData = await response.json();

                if (responseData) {
                    setSubscription(responseData.subscription || null);
                    setCurrentPlan(responseData.plan || null);
                    setPlans(responseData.plans || null);
                    setPlanPeriod(responseData.plan?.period || 'month');
                    setTrialEndDate(responseData.trialEndDate || null);
                    if (typeof responseData.discountPercent === 'number' && responseData.discountPercent > 0) {
                        setDiscountPercent(responseData.discountPercent);
                    }

                    dispatch(updateSubscriptionDataFromHook({
                        subscription: responseData.subscription || null,
                    }));
                }
            } catch (error) {
                console.error('Error fetching subscription data:', error);
            } finally {
                setIsLoading(false);
            }
        };

        if (auth && auth.user && auth.user.token) {
            fetchData();
        } else {
            setIsLoading(false);
        }

    }, [auth, searchParams]);

    return {
        isLoading,
        subscription,
        currentPlan,
        plans,
        planPeriod,
        setPlanPeriod,
        trialEndDate,
        discountPercent,
    };
};

export default useSubscriptionPlans;
